import { render, staticRenderFns } from "./SongList.vue?vue&type=template&id=4e878316&scoped=true"
import script from "./SongList.vue?vue&type=script&lang=js"
export * from "./SongList.vue?vue&type=script&lang=js"
import style0 from "./SongList.vue?vue&type=style&index=0&id=4e878316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e878316",
  null
  
)

export default component.exports